(function (angular) {
    angular.module('bizPartEngage').service('modules.media.service', mediaService);

    mediaService.$inject = ["$http", "$rootScope"];

    function mediaService($http, $rootScope) {

        this.GetMediaFiles = function (fileTypes, tagIds, getRelatedFiles, includeViews, journeyOrder) {
            return $http.post(siteRootPath + "api/MediabankUser/GetMediaBankFilesForUser",
                { FileTypes: fileTypes, TagIds: tagIds, GetRelatedFiles: getRelatedFiles, IncludeViews: includeViews, JourneyOrder: journeyOrder || false });
        };

        this.GetGenericSetting = function (key) {
            return $http.get(siteRootPath + "api/mediabankuser/GetGenericSetting?" + $.param({ key: key }));
        };

        this.GetGenericSettings = function (keys) {
            return $http.get(siteRootPath + "api/genericsetting/GetGenericSettings?" + $.param({ type: 'MEDIABANK', keys: keys }));
        };

        this.GetMediaFileTypes = function () {
            return $http.get(siteRootPath + "api/mediabankuser/GetMediaFileTypes");
        };

        this.GetTag = function (id) {
            return $http.get(siteRootPath + "api/generictag/getTags?" + $.param({ tagIds: id }));
        }
        this.GetTagBySystemName = function (systemName) {
        	return $http.get(siteRootPath + "api/generictag/getTagBySystemName?" + $.param({ tagSystemName: systemName }));
        }

        this.AddLikeActionToMediaFile = function (entryId, actionId) {
            return $http.post(siteRootPath + 'api/mediabankuser/AddLikeActionToMediaFile', { objectId: entryId, actionId: actionId }, { ignoreLoadingBar: true });
        }       
    }
})(window.angular);
